import React from "react";
import BaeminPlatformOrderImporterProvider from "./provider";
import {Modal} from "react-bootstrap";
import Views from "./views";

interface BaeminPlatformOrderImporterType {
  onClose: () => void;
  show: boolean;
  code: any;
  orderId: string;
  storeId: string;
  provider: string;
  fromExistOrder: boolean
}

const BaeminPlatformOrderImporter = (props: BaeminPlatformOrderImporterType) => {

  return (
    <BaeminPlatformOrderImporterProvider fromExistOrder={props.fromExistOrder}>
      <Modal show={props.show} onHide={props.onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Nhập đơn Baemin { props.code }
          </Modal.Title>
        </Modal.Header>
        <Views
          id={props.orderId}
          show={props.show}
          close={props.onClose}
          storeId={props.storeId}
          provider={props.provider}/>
      </Modal>
    </BaeminPlatformOrderImporterProvider>
  )
}

export default BaeminPlatformOrderImporter;